function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRabbit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d5zkauoc1a"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M0 0h28v28H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#d5zkauoc1a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.642 21.925c.615 0 1.2-.3 2.356-.3s1.494.3 2.364.3c1.3 0 2.013-.554 2.013-1.477 0-1.547-1.608-2.663-4.28-2.663a9.823 9.823 0 0 0-2.689.334l-.976-2.2a5.141 5.141 0 0 0-4.7-3.393H7.681c-.387 0-.633-.167-.633-.536 0-.589.765-.738 1.6-.738 2.637 0 4.649 1.415 5.871 4.307l.6 1.415a9.442 9.442 0 0 1 1.89-.176 8.7 8.7 0 0 1 1.512.123 13.557 13.557 0 0 1 1.979-1.113 6.094 6.094 0 0 0 3.472 1.169c2.3 0 3.41-.589 3.41-2.909a4.706 4.706 0 0 0-4.8-4.939L20.31 6.017a5.662 5.662 0 0 0-4.491-2.575c-1.3 0-3.322.729-3.322 1.775 0 .686 1.441 1.679 2.549 2.373l5 3.129a1.677 1.677 0 0 1-1.2.571 5.661 5.661 0 0 1-2.487-1.037C13.6 8.618 11.592 7.168 8.691 7.168s-5.212 1.644-6.4 5.01a1.532 1.532 0 0 0-1.67 1.512 1.707 1.707 0 0 0 1.925 1.644c1.3 1.934 3.331 2.681 5.915 2.681.141 0 .281-.009.422-.009l3.595 2.988a2.9 2.9 0 0 0 2.164.931zm8.947-8.235a.773.773 0 0 1-.765-.773.806.806 0 0 1 .774-.809.773.773 0 0 1 .773.765.815.815 0 0 1-.782.816zm-15.5 8.938a5.94 5.94 0 0 0 3.56-.888l-2.711-2.259a5.743 5.743 0 0 1-.439.018c-.439 0-1.134-.132-1.9-.132-.976 0-1.582.527-1.582 1.31.001 1.177 1.205 1.951 3.068 1.951z",
    style: {
      fill: "currentColor"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRabbit);
export default __webpack_public_path__ + "static/media/rabbit.aa23f980.svg";
export { ForwardRef as ReactComponent };